import { Group } from './group.model';

export class CalendarEvent {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.title = json && json.title || null;
        this.allDay = json && json.event_all_day || null;
        this.portalID = json && json.portal_id || null;
        this.portalLogo = json && json.portal_logo|| null;

        this.groups = [];
        if (json && json.groups) {
          json.groups.forEach(group => {
            this.groups.push(new Group(group));
          })
        }
    }

    id: number;
    title: string;
    allDay: boolean;
    portalID: number
    portalLogo: string;
    startTime: Date;
    endTime: Date;
    eventDate: Date;
    eventEndDate: Date;
    groups: Group[];
    eventType: string;
    location: string;

    copy() : CalendarEvent {
      let c = new CalendarEvent();
      c.id = this.id;
      c.title = this.title;
      c.allDay = this.allDay;
      c.portalID = this.portalID;
      c.portalLogo = this.portalLogo;
      c.startTime = new Date(this.startTime);
      c.endTime = new Date(this.endTime);
      c.eventDate = new Date(this.eventDate);
      c.eventEndDate = new Date(this.eventEndDate);
      c.groups = this.groups;
      c.eventType = this.eventType;
      c.location = this.location;

      return c;
    }
}


